module.exports = __webpack_public_path__ + "static/media/educar.5878e66d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/thumbs/educar.jpg
// module id = 235
// module chunks = 0